/* eslint-disable max-len */
import { httpApi } from "./http.api";

interface ReportFilters {
  name?: string;
  job?: string | number;
  template?: string;
  created_after?: string;
  created_before?: string;
  author?: string;
  page?: number;
  search?: string;
}

export const getCandidatesByReportId = async (reportId: any): Promise<any> => {
  //   const { data } = await httpApi.post<any>("/users/mail/send-mail/", candidateSendEmailPayload);
  const data = [
    {
      id: 62340,
      graph_profile_id: 27426458,
      full_name: "Lauren Galle",
      bio: "I am a User Experience designer based in Portland, Oregon. My main goal in my work is to help products incorporate best practices of user experience design and human computer interaction into their current processes. Often within tech industry, the technology behind a product can be strong but there is little thought put into who will actually by interacting with it: the user. Throughout my time as a UX designer thus far, I have enjoyed tackling this problem. From conducting discovery interviews early on, to collaborating with real users on their ideal designs, to testing these designs before feature release, every step is imperative to creating the best experience. Feel free to message me on LinkedIn or at laurengalle99@gmail.com for any questions.",
      email: "laurengalle99@gmail.com",
      location: "Portland, OR, USA",
      education_experience: [
        {
          field: "Computer Science",
          degree: "Bachelor of Science - BS",
          end_date: "2021-12-31",
          logo_url: null,
          schoolName: "Oregon State University",
          start_date: "2017-01-01",
          description: null,
          end_date_formatted: "Dec, 2021",
          start_date_formatted: "Jan, 2017",
        },
      ],
      work_experience: [
        {
          id: 78547062,
          industry: "Information Technology and Services",
          location: null,
          logo_url:
            "https://storage.googleapis.com/content-crawling-graph-images/1a/1ab66c8c1065d80e42cd3164ca20d39a3586571b/downloaded_company_logo_url.jpg",
          volunteer: false,
          company_id: 11349,
          description: null,
          designation: "UX Designer",
          company_name: "Trimble Inc.",
          linkedin_size: null,
          role_end_date: null,
          role_start_date: "2023-06-01",
          company_linkedin_url: "https://www.linkedin.com/company/trimble/",
          role_end_date_formatted: "Present 2 years",
          role_start_date_formatted: "Jun, 2023",
        },
        {
          id: 78547063,
          industry: "Computer Software",
          location: "Portland, Oregon Metropolitan Area",
          logo_url:
            "https://storage.googleapis.com/content-crawling-graph-images/b8/b8d74f4ffdf942ed55bd44100c6d542eb8f30a9c/downloaded_company_logo_url.jpg",
          volunteer: false,
          company_id: 306927,
          description: null,
          designation: "Software Developer",
          company_name: "Viewpoint",
          linkedin_size: null,
          role_end_date: "2023-06-30",
          role_start_date: "2021-07-01",
          company_linkedin_url: "https://www.linkedin.com/company/viewpoint-construction-software/",
          role_end_date_formatted: "Jun, 2023",
          role_start_date_formatted: "Jul, 2021",
        },
        {
          id: 78547065,
          industry: null,
          location: "Portland, Oregon Area",
          logo_url:
            "https://storage.googleapis.com/content-crawling-graph-images/20/207d967b49bcb141c591e2f0e2bdf0884a31d985/downloaded_company_logo_url.jpg",
          volunteer: false,
          company_id: 10561478,
          description:
            "I provided knowledgeable recommendations and assistance to customers finding their desired product. I accurately and promptly prepared customers’ orders, often during a busy and high-stress environment. On an average day, I opened or closed the deli station daily, ensuring a successful operation for that day.",
          designation: "Kitchen Clerk",
          company_name: "Market of Choice",
          linkedin_size: null,
          role_end_date: "2019-09-30",
          role_start_date: "2019-06-01",
          company_linkedin_url: "https://www.linkedin.com/company/marketofchoice/",
          role_end_date_formatted: "Sep, 2019",
          role_start_date_formatted: "Jun, 2019",
        },
        {
          id: 78547067,
          industry: "Retail",
          location: "Beaverton, Oregon",
          logo_url:
            "https://storage.googleapis.com/content-crawling-graph-images/51/5124ffdcf7d081c6899f31f3dd2cc0dcc9f3ee91/downloaded_company_logo_url.jpg",
          volunteer: false,
          company_id: 1366,
          description:
            "I was invited as a freshman to participate in a day-long computer science innovation challenge. With a team, I formulated a customer-centered, sustainable solution to a hypothetical problem.",
          designation: "Nike Technology Collegiate Experience",
          company_name: "Nike",
          linkedin_size: null,
          role_end_date: "2018-04-30",
          role_start_date: "2018-04-01",
          company_linkedin_url: "https://www.linkedin.com/company/nike/",
          role_end_date_formatted: "Apr, 2018",
          role_start_date_formatted: "Apr, 2018",
        },
        {
          id: 78547069,
          industry: null,
          location: "Oregon State University",
          logo_url: null,
          volunteer: false,
          company_id: null,
          description:
            "Within this committee, I participated in dynamic discussions around women in computer science. I also actively engaged in onsite company visits while developing networking skills.",
          designation:
            "Member of The Association for Computing Machinery's Committee on Women in Computing",
          company_name: "ACM-W",
          linkedin_size: null,
          role_end_date: "2021-06-30",
          role_start_date: "2018-01-01",
          company_linkedin_url: null,
          role_end_date_formatted: "Jun, 2021",
          role_start_date_formatted: "Jan, 2018",
        },
        {
          id: 78547066,
          industry: "Non-profit Organization Management",
          location: "Corvallis, Oregon Area",
          logo_url:
            "https://storage.googleapis.com/content-crawling-graph-images/2d/2d76ec17c506069e0c31deac0c887edd7b33eee8/downloaded_company_logo_url.jpg",
          volunteer: false,
          company_id: 11099242,
          description:
            "I collaborated and supported a sorority of female engineers. I also designed, managed, and presented highly curated sorority merchandise within a strict budget.",
          designation: "Merchandiser Chair",
          company_name: "Phi Sigma Rho National Sorority",
          linkedin_size: null,
          role_end_date: "2019-04-30",
          role_start_date: "2018-01-01",
          company_linkedin_url: "https://www.linkedin.com/company/phisigmarho/",
          role_end_date_formatted: "Apr, 2019",
          role_start_date_formatted: "Jan, 2018",
        },
        {
          id: 78547068,
          industry: "Information Technology and Services",
          location: "Portland, Oregon Area",
          logo_url: null,
          volunteer: false,
          company_id: 2627638,
          description:
            "I maintained an energetic and positive attitude throughout the day and managed a strict work schedule based on the family’s needs.",
          designation: "Nanny and Babysitter",
          company_name: "N/A",
          linkedin_size: null,
          role_end_date: "2017-09-30",
          role_start_date: "2014-09-01",
          company_linkedin_url: "https://uk.linkedin.com/company/north-kingstown-high-school/",
          role_end_date_formatted: "Sep, 2017",
          role_start_date_formatted: "Sep, 2014",
        },
      ],
      intern_and_volunteer_experience: [
        {
          id: 78547064,
          industry: "Computer Software",
          location: "Portland, Oregon, United States",
          logo_url:
            "https://storage.googleapis.com/content-crawling-graph-images/b8/b8d74f4ffdf942ed55bd44100c6d542eb8f30a9c/downloaded_company_logo_url.jpg",
          volunteer: false,
          company_id: 306927,
          description:
            "I worked on a development team to improve the on-boarding experience for new employees at Viewpoint. Through the use of test driven development, I improved the process of importing data to the develop database and utilized Angular to create a more effective user interface.",
          designation: "Intern",
          company_name: "Viewpoint",
          linkedin_size: null,
          role_end_date: "2020-09-30",
          role_start_date: "2020-06-01",
          company_linkedin_url: "https://www.linkedin.com/company/viewpoint-construction-software/",
          role_end_date_formatted: "Sep, 2020",
          role_start_date_formatted: "Jun, 2020",
        },
      ],
      licenses: [],
      skills:
        "Good Documentation Practices, Machinery, Software Development, Collaboration, Interactivity, Industrialization, Human-Computer Interaction, Experience Design, User Experience Design (Ux), User Experience",
      profile_image_url:
        "https://storage.googleapis.com/content-crawling-graph-images/8f/8f915c47a76c0b10dec9e006994b24c9aec45d81/downloaded_profile_picture.jpg",
      linkedin_url: "https://www.linkedin.com/in/lauren-galle-775724187/",
      titles: "UX Designer",
      emails: ["laurengalle99@gmail.com"],
      tags: {
        VIEWED: ["<b>You</b> Viewed June 04, 2025", "<b>Nataliya S.</b> Viewed February 13, 2025"],
        ADDED_TO_TALENT_POOL: ["<b>You</b> added to <b>Director of Sales</b> May 22, 2025"],
        ADDED_TO_PROJECT: ["<b>Nataliya S.</b> added to <b>ux designer</b> January 27, 2025"],
      },
      npi: null,
      notes: [],
      interview_details: [],
      duration_in_job: 2.0,
      duration_in_job_str: "2 years 1 month",
      total_experience: 10.8,
      total_experience_str: "10 years 9 months",
    },
    {
      id: 58039,
      graph_profile_id: 27491312,
      full_name: "Sandy Liao",
      bio: "Hello, I'm Sandy! 👋👩‍💻 With over 6 years of professional design experience, I enjoy solving problems in data-driven storytelling settings. My approach involves understanding user needs and product goals, crafting and iterating designs, and delivering user-friendly solutions. :)📩 Please feel free to reach out to me at sandyliaodesign@gmail.com. Let's connect and collaborate!",
      email: "sandyliaodesign@gmail.com",
      location: "Los Angeles, CA, USA",
      education_experience: [
        {
          field: "NA",
          degree: "Innovation and Entrepreneurship Program",
          end_date: null,
          logo_url: null,
          schoolName: "Stanford University Graduate School of Business",
          start_date: null,
          description: "Skills: Product Development · Strategy",
          end_date_formatted: null,
          start_date_formatted: null,
        },
        {
          field: "Architectural and Building Sciences/Technology",
          degree: "Master's degree",
          end_date: null,
          logo_url: null,
          schoolName: "SCI-Arc",
          start_date: null,
          description:
            "• 2019 Graduate Thesis Miniature Exhibition at HAUSER & WIRTH Los Angeles• 2018 and 2019 Spring Show",
          end_date_formatted: null,
          start_date_formatted: null,
        },
        {
          field: "NA",
          degree: "User Experience Design",
          end_date: null,
          logo_url: null,
          schoolName: "Springboard",
          start_date: null,
          description:
            "Skills: Information Architecture · Prototyping · Design Thinking · User-centered Design · Figma (Software) · Usability Testing · User Interface Design · User Experience (UX) · Wireframing · Product Design · User Research",
          end_date_formatted: null,
          start_date_formatted: null,
        },
        {
          field: "Architecture",
          degree: "College of Design",
          end_date: null,
          logo_url: null,
          schoolName: "Iowa State University",
          start_date: null,
          description: "• Designed and built the IM_RU pavilion for the 2017 Flyover Fashion Fest",
          end_date_formatted: null,
          start_date_formatted: null,
        },
      ],
      work_experience: [
        {
          id: 78938948,
          industry: "Electrical and Electronic Manufacturing",
          location: "Cypress, California, United States",
          logo_url:
            "https://storage.googleapis.com/content-crawling-graph-images/c1/c1ce1a4feb02f77b0c748ace7229b08f545bfdae/downloaded_company_logo_url.jpg",
          volunteer: false,
          company_id: 2931494,
          description: "Enhancing experiences for payments, merchants, and CRMs",
          designation: "UI/UX Designer",
          company_name: "ID TECH",
          linkedin_size: null,
          role_end_date: null,
          role_start_date: "2024-10-01",
          company_linkedin_url: "https://www.linkedin.com/company/id-tech/",
          role_end_date_formatted: "Present 8 months",
          role_start_date_formatted: "Oct, 2024",
        },
        {
          id: 78938949,
          industry: null,
          location: "Mountain View, California",
          logo_url:
            "https://storage.googleapis.com/content-crawling-graph-images/16/16bf8b37c6715de7c8bbec68b1d55b6b226485de/downloaded_company_logo_url.jpg",
          volunteer: false,
          company_id: 12940825,
          description: null,
          designation: "Senior Product Designer",
          company_name: "Recly",
          linkedin_size: null,
          role_end_date: "2024-09-30",
          role_start_date: "2023-07-01",
          company_linkedin_url: "https://www.linkedin.com/company/recly/",
          role_end_date_formatted: "Sep, 2024",
          role_start_date_formatted: "Jul, 2023",
        },
        {
          id: 78938950,
          industry: null,
          location: "London, United Kingdom",
          logo_url:
            "https://storage.googleapis.com/content-crawling-graph-images/b7/b75ac4867cbd66346c1165ff737b737ebd5ef86a/downloaded_company_logo_url.jpg",
          volunteer: false,
          company_id: 12940826,
          description: null,
          designation: "UX Designer",
          company_name: "playroom",
          linkedin_size: null,
          role_end_date: "2023-06-30",
          role_start_date: "2023-04-01",
          company_linkedin_url: "https://www.linkedin.com/company/playroom-app/",
          role_end_date_formatted: "Jun, 2023",
          role_start_date_formatted: "Apr, 2023",
        },
        {
          id: 78938951,
          industry: "E-learning",
          location: "San Francisco, California",
          logo_url:
            "https://storage.googleapis.com/content-crawling-graph-images/58/58ef9df2bc8eb6f9980f6f38eb79b1858aa33d30/downloaded_company_logo_url.jpg",
          volunteer: false,
          company_id: 133240,
          description: null,
          designation: "UX Design Fellow",
          company_name: "Springboard",
          linkedin_size: null,
          role_end_date: "2023-05-31",
          role_start_date: "2022-10-01",
          company_linkedin_url: "https://www.linkedin.com/school/springboard/",
          role_end_date_formatted: "May, 2023",
          role_start_date_formatted: "Oct, 2022",
        },
        {
          id: 78938952,
          industry: null,
          location: "Culver City, California",
          logo_url:
            "https://storage.googleapis.com/content-crawling-graph-images/61/612f1c7105b945a1b2a4c799be6ff8d2e77d7651/downloaded_company_logo_url.jpg",
          volunteer: false,
          company_id: 12357172,
          description: null,
          designation: "Designer",
          company_name: "Shubin + Donaldson Architects, Inc.",
          linkedin_size: null,
          role_end_date: "2022-11-30",
          role_start_date: "2018-05-01",
          company_linkedin_url: "https://www.linkedin.com/company/donaldsonandpartners/",
          role_end_date_formatted: "Nov, 2022",
          role_start_date_formatted: "May, 2018",
        },
        {
          id: 78938955,
          industry: "Higher Education",
          location: null,
          logo_url:
            "https://storage.googleapis.com/content-crawling-graph-images/1d/1dab2cf79a3c75b46c9b3af1b6ffe2ffffe8eae0/downloaded_company_logo_url.jpg",
          volunteer: false,
          company_id: 12878,
          description: null,
          designation: "Research Assistant, Department of Wood Science",
          company_name: "The University of British Columbia",
          linkedin_size: null,
          role_end_date: "2016-08-31",
          role_start_date: "2015-07-01",
          company_linkedin_url: "https://www.linkedin.com/company/universityofbc/",
          role_end_date_formatted: "Aug, 2016",
          role_start_date_formatted: "Jul, 2015",
        },
        {
          id: 78938956,
          industry: null,
          location: "Taiwan",
          logo_url: null,
          volunteer: false,
          company_id: null,
          description: null,
          designation: "Architectural Designer",
          company_name: "C. H. Wu Architect & Associates",
          linkedin_size: null,
          role_end_date: "2015-06-30",
          role_start_date: "2013-07-01",
          company_linkedin_url: null,
          role_end_date_formatted: "Jun, 2015",
          role_start_date_formatted: "Jul, 2013",
        },
      ],
      intern_and_volunteer_experience: [
        {
          id: 78938953,
          industry: null,
          location: "Culver City, California",
          logo_url:
            "https://storage.googleapis.com/content-crawling-graph-images/61/612f1c7105b945a1b2a4c799be6ff8d2e77d7651/downloaded_company_logo_url.jpg",
          volunteer: false,
          company_id: 12357172,
          description: null,
          designation: "Design Intern, R&D",
          company_name: "Shubin + Donaldson Architects, Inc.",
          linkedin_size: null,
          role_end_date: "2018-08-31",
          role_start_date: "2018-05-01",
          company_linkedin_url: "https://www.linkedin.com/company/donaldsonandpartners/",
          role_end_date_formatted: "Aug, 2018",
          role_start_date_formatted: "May, 2018",
        },
        {
          id: 78938954,
          industry: "Architecture and Planning",
          location: null,
          logo_url:
            "https://storage.googleapis.com/content-crawling-graph-images/60/6093c76cbc8f172a2df9283e7f136da30c3674df/downloaded_company_logo_url.jpg",
          volunteer: false,
          company_id: 151215,
          description: null,
          designation: "Professional Design Internship",
          company_name: "Gensler",
          linkedin_size: null,
          role_end_date: "2016-09-30",
          role_start_date: "2016-06-01",
          company_linkedin_url: "https://www.linkedin.com/company/gensler/",
          role_end_date_formatted: "Sep, 2016",
          role_start_date_formatted: "Jun, 2016",
        },
      ],
      licenses: [
        {
          url: null,
          name: "LEED Green Associate",
          valid: true,
          ends_at: null,
          verified: false,
          authority: "U.S. Green Building Council",
          starts_at: "2020-06-01",
          date_added: "2025-01-24",
          profile_role: "mentions",
          display_source: null,
          license_number: "11250763",
          ends_at_formatted: null,
          starts_at_formatted: "Jun, 2020",
        },
        {
          url: null,
          name: "Assoc. AIA",
          valid: true,
          ends_at: null,
          verified: false,
          authority: "The American Institute of Architects (AIA)",
          starts_at: "2020-09-01",
          date_added: "2025-01-24",
          profile_role: "mentions",
          display_source: null,
          license_number: "39243706",
          ends_at_formatted: null,
          starts_at_formatted: "Sep, 2020",
        },
        {
          url: null,
          name: "WELL Accredited Professional",
          valid: true,
          ends_at: null,
          verified: false,
          authority: "International WELL Building Institute (IWBI)",
          starts_at: "2021-08-01",
          date_added: "2025-01-24",
          profile_role: "mentions",
          display_source: null,
          license_number: "00000114588",
          ends_at_formatted: null,
          starts_at_formatted: "Aug, 2021",
        },
        {
          url: "https://www.coursera.org/account/accomplishments/verify/VM6H9UY8DNE4",
          name: "Agile Project Management",
          valid: true,
          ends_at: null,
          verified: false,
          authority: "Google",
          starts_at: "2023-02-01",
          date_added: "2025-01-24",
          profile_role: "mentions",
          display_source: "coursera.org",
          license_number: "VM6H9UY8DNE4",
          ends_at_formatted: null,
          starts_at_formatted: "Feb, 2023",
        },
      ],
      skills:
        "Complex Problem Solving, Learning Experience Design, Architectural Design, Collaboration, Friendliness, Iterative Design, Storytelling, Problem Solving, Experience Design, Professionalism, Research, Product Design, Project Management, Agile Project Management, Agile Projects, User Experience",
      profile_image_url:
        "https://storage.googleapis.com/content-crawling-graph-images/2a/2ae952841e7798b44644ef5d68489927a2241463/downloaded_profile_picture.jpg",
      linkedin_url: "https://www.linkedin.com/in/sandylliao/",
      titles: "UI/UX Designer",
      emails: ["sandyliaodesign@gmail.com"],
      tags: {
        VIEWED: ["<b>You</b> Viewed June 04, 2025", "<b>Aun R.</b> Viewed April 21, 2025"],
        ADDED_TO_TALENT_POOL: ["<b>You</b> added to <b>Director of Sales</b> May 22, 2025"],
        ADDED_TO_PROJECT: ["<b>Nataliya S.</b> added to <b>ux designer</b> January 27, 2025"],
      },
      npi: null,
      notes: [],
      interview_details: [],
      duration_in_job: 0.7,
      duration_in_job_str: "8 months",
      total_experience: 11.9,
      total_experience_str: "12 years",
    },
  ];
  return data;
};

export const getAllReportTemplates = (): Promise<any[]> =>
  httpApi.get<any[]>(`report/report-template/`).then((res) => res.data);

// export const getReportTemplates = (reportId: number): Promise<any[]> =>
//     httpApi.get<any[]>(`report/report-template/${reportId}/`).then((data: any) => data.data);

export const getReportTemplateById = (templateId: number): Promise<any> =>
  httpApi.get<any>(`report/report-template/${templateId}/`).then((res) => res.data);

export const getAllReports = (params?: ReportFilters): Promise<any> =>
  httpApi.get<any>("report/report/", { params }).then((res) => res.data);

export const deleteReport = (id: string | number): Promise<any> =>
  httpApi.delete<any>(`report/report/${id}`).then((res) => res.data);

export const uploadImages = (formData: FormData): Promise<any> =>
  httpApi.post<any>(`report/image-upload/`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  }).then((res) => res.data);

export const deleteMultipleReport = (reportIds: number[]): Promise<any> =>
  httpApi
    .post<any>(
      "/report/report/delete-reports/",
      {
        report_ids: reportIds,
      }
    )
    .then((res) => res.data);

// export const getAllReports = (): Promise<any> =>
//   httpApi.get<any>(`report/report`).then((res) => res.data);

export const getReportById = (reportId: number): Promise<any> =>
  httpApi.get<any>(`report/report/${reportId}/`).then((res) => res.data);

export const createReport = (data: {
  name: string;
  job: number;
  candidate_ids: number[];
  report_format: string;
}): Promise<any> =>
  httpApi
    .post<any>(`report/report/`, {
      ...data,
      candidate_ids: data.candidate_ids || [],
      report_format: data.report_format, //slide, pdf, docx
    })
    .then((res) => res.data);

export const getCandidateDetails = (data: { job_id: number; candidate_id: number }): Promise<any> =>
  httpApi.post<any>(`report/profile-evaluation/`, data).then((res) => res.data);

export const updateCandidateDetails = (data: {
  report_id: number;
  candidate_id: number;
  candidate_data: any;
}): Promise<any> =>
  httpApi.post<any>(`report/report-candidate-data/`, data).then((res) => res.data);


  export const updateCandidateColor = (data: {
  report_id: number;
  candidate_id: number;
  candidate_data: any;
}): Promise<any> =>
  httpApi.post<any>(`report/report-candidate-data/`, data).then((res) => res.data);

export const createReportTemplateForm = (payload: any): Promise<any> => {
  return httpApi
    .post<any>(`report/report-template/`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => res.data);
};

export const updateReportTemplateForm = (payload: any, templateId: number): Promise<any> => {
  return httpApi
    .patch<any>(`report/report-template/${templateId}/`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => {
      return {
        ...res.data.data,
        templateId: templateId, // Ensure the templateId is returned
        ...res.data,
      };
    });
};

export const updateReport = (reportId: number, payload: any): Promise<any> => {
  return httpApi
    .patch<any>(`report/report/${reportId}/`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => res.data?.report);
};

export const generatePDFfromElement = async ({
  elementId,
  reportId,
  width = "13.3in",
  height = "7.5in",
  date,
  logoImage,
}: {
  elementId: string;
  reportId: string | number;
  width?: string;
  height?: string;
  date?: string;
  logoImage?: any;
  token: string;
}) => {
  // 1. Get HTML element
  const element = document.getElementById(elementId);
  if (!element) {
    throw new Error(`Element with id '${elementId}' not found.`);
  }

  const clonedElement = element.cloneNode(true) as HTMLElement;
  // 2. Get outer HTML and wrap it in a File
  clonedElement.classList.add("print");
  const htmlContent = clonedElement.outerHTML;


  const htmlBlob = new Blob([htmlContent], { type: "text/html" });
  const htmlFile = new File([htmlBlob], "document.html", { type: "text/html" });
  // const headerBlob = new Blob([headerHTML], { type: "text/html" });
  // const headerFile = new File([headerBlob], "header.html", { type: "text/html" });
  // const footerBlob = new Blob([footerHML], { type: "text/html" });
  // const footerFile = new File([footerBlob], "footer.html", { type: "text/html" });

  // 3. Create FormData
  const formData = new FormData();
  formData.append("report_id", String(reportId));
  formData.append("width", width);
  formData.append("height", height);
  formData.append("margin_left", "0in");
  formData.append("margin_right", "0in");
  formData.append("margin_top", "0in");
  formData.append("margin_bottom", "0in");
  formData.append("html_file", htmlFile);
  // formData.append("header_html_file", headerFile);
  formData.append("report_format", "pdf"); // Specify the format as PDF
  // formData.append("footer_html_file", footerFile);
  // 4. Call the API
  const responseBlob = await httpApi
    .post<Blob>("report/html-to-pdf/", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      responseType: "blob", // important for binary response like PDF
    })
    .then((res) => res.data);
  // 5. Display PDFd
  return responseBlob;
};

export const deleteReportImage = (reportId: number, field: string): Promise<any> => {
  return httpApi
    .delete(`report/report-template/${reportId}/delete-image/`, {
      params: { field },
    })
    .then((res) => res.data);
};

export const generateReportContent = async (
  reportId: number,
  companyName: string,
  hiringCompany: string
): Promise<any> => {
  return httpApi
    .post<any>("report/report/generate-report-content/", {
      report_id: reportId,
      company_name: companyName,
      hiring_company: hiringCompany,
    })
    .then((res) => res.data);
};
